export default {
  GET_PASSWORD_EXPIRATION_REQUEST: '@@user-password-expiration/GET_PASSWORD_EXPIRATION_REQUEST',
  GET_PASSWORD_EXPIRATION_SUCCESS: '@@user-password-expiration/GET_PASSWORD_EXPIRATION_SUCCESS',
  GET_PASSWORD_EXPIRATION_ERROR: '@@user-password-expiration/GET_PASSWORD_EXPIRATION_ERROR',

  SET_PASSWORD_EXPIRATION_REQUEST: '@@user-password-expiration/SET_PASSWORD_EXPIRATION_REQUEST',
  SET_PASSWORD_EXPIRATION_SUCCESS: '@@user-password-expiration/SET_PASSWORD_EXPIRATION_SUCCESS',
  SET_PASSWORD_EXPIRATION_ERROR: '@@user-password-expiration/SET_PASSWORD_EXPIRATION_ERROR',
};
